package gr.tech.site.components.states

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.site.data.RebateIcon
import gr.tech.site.data.RebateType
import gr.tech.site.styles.landings.LandingRebateCardBodyStyle
import gr.tech.site.styles.landings.LandingRebateCardStyle
import gr.tech.site.styles.landings.LandingRebateCardTitleStyle
import org.jetbrains.compose.web.dom.*

@Composable
fun RebateTypeGrid(rebateTypes: List<RebateType>, stateName: String) {
    Div(
        attrs = Modifier
            .classNames("row", "row-cols-1", "row-cols-sm-2", "row-cols-lg-3", "g-4")
            .toAttrs()
    ) {
        rebateTypes.forEach { type ->
            Div(attrs = Modifier.classNames("col").toAttrs()) {
                RebateTypeCard(type = type, stateName = stateName)
            }
        }
    }
}

@Composable
fun RebateTypeCard(type: RebateType, stateName: String) {
    Div(attrs = LandingRebateCardStyle.toModifier().toAttrs()) {
        RebateTypeIcon(icon = type.icon)
        H5(attrs = LandingRebateCardTitleStyle.toModifier().classNames("mb-2").toAttrs()) {
            Text(type.name)
        }
        P(attrs = LandingRebateCardBodyStyle.toModifier().classNames("mb-0").toAttrs()) {
            Text(type.descriptionFor(stateName))
        }
    }
}

@Composable
private fun RebateTypeIcon(icon: RebateIcon) {
    val mod = Modifier.classNames("mb-3")
    when (icon) {
        RebateIcon.Lighting        -> FaLightbulb(modifier = mod, size = IconSize.X2)
        RebateIcon.Hvac            -> FaFan(modifier = mod, size = IconSize.X2)
        RebateIcon.Dehu            -> FaDroplet(modifier = mod, size = IconSize.X2)
        RebateIcon.Greenhouse      -> FaSeedling(modifier = mod, size = IconSize.X2)
        RebateIcon.Irrigation      -> FaWater(modifier = mod, size = IconSize.X2)
        RebateIcon.EvChargers      -> FaBolt(modifier = mod, size = IconSize.X2)
        RebateIcon.ShadeInsulation -> FaLayerGroup(modifier = mod, size = IconSize.X2)
        RebateIcon.Processing      -> FaGear(modifier = mod, size = IconSize.X2)
        RebateIcon.Other           -> FaCircleQuestion(modifier = mod, size = IconSize.X2)
    }
}
